import { render } from './corona-numbers';

const statesEn = {
  Deutschland: 'Germany',
  'Baden-Württemberg': 'Baden-Wuerttemberg',
  Bayern: 'Bavaria',
  Hessen: 'Hesse',
  Niedersachsen: 'Lower Saxony',
  'Mecklenburg-Vorpommern': 'Mecklenburg-Western Pomerania',
  'Nordrhein-Westfalen': 'North Rhine-Westphalia',
  'Rheinland-Pfalz': 'Rhineland-Palatinate',
  Sachsen: 'Saxony',
  'Sachsen-Anhalt': 'Saxony-Anhalt',
  Thüringen: 'Thuringia',
};

class CoronaStatistics {
  constructor(element) {
    this.initialized = false;
    this.element = element;
    this.config = JSON.parse(document.getElementById(`${element.id}_data`).innerHTML);
    this.value = null;
    this.stateMapping = {};

    this.container = element.querySelector('.coronaStatistics__select');
    this.text = element.querySelector('.coronaStatistics__text');
    this.tiles = element.querySelector('.coronaStatistics__tiles');
  }

  translateState(state) {
    if (document.documentElement.lang === 'en') {
      state = statesEn[state] || state;
    }
    return state;
  }

  renderSelect(stateMapping) {
    if (this.initialized) {
      return;
    }
    this.stateMapping = stateMapping;
    const selectEl = document.createElement('d4l-select');
    selectEl.label = this.config.selectlabel;
    selectEl.options = Object.entries(stateMapping).map(([key, value]) => ({
      value: key,
      text: this.translateState(value),
    }));
    selectEl.value = this.value || Object.keys(stateMapping)[0];
    selectEl.handleChange = ({ target }) => this.onChange(target.value);

    this.container.innerHTML = '';
    this.container.appendChild(selectEl);

    this.initialized = true;
    this.onChange(selectEl.value);
  }

  renderTiles(stateKey) {
    let tiles = '';
    Object.values(this.config.tiles).forEach((tile) => {
      const { bgcolor, headline, subline } = tile.content;
      tiles += `<div class="coronaStatistics__tile" style="background-color: ${bgcolor}">
        ${headline.replace(/\{stateKey\}/g, stateKey)}
        <span>${subline}</span>
      </div>`;
    });
    return tiles;
  }

  onChange(stateKey) {
    const stateName = this.translateState(this.stateMapping[stateKey]);

    this.text.innerHTML = this.config.text.replace(/\{stateName\}/g, stateName).replace(/\{stateKey\}/g, stateKey);
    if (this.tiles) {
      this.tiles.innerHTML = this.renderTiles(stateKey);
    }

    this.value = stateKey;
    render();
  }
}

const init = () => {
  const instances = [...document.querySelectorAll('.js-coronaStatistics')].map((el) => new CoronaStatistics(el));

  window.addEventListener('coronaNumbersRendered', ({ detail }) => {
    instances.forEach((instance) => instance.renderSelect(detail));
  });
};

export { init };
